export default __webpack_public_path__ + "images/assets/40cf5e935e1fe5cd7e09d1251f7825d6.svg";